import { NotificationTypes, NotificationUpdatePayloadTypes } from 'types/notification';
import baseApi, { API_V1 } from './base';
const API_NOTIFICATION = `${API_V1}/Notification`;

const notificaitonApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getNotificationCount: build.query<number, void>({
      query: () => ({
        url: `${API_NOTIFICATION}/GetCount`
      }),
      providesTags: ['notificationCount' as any]
    }),
    getNotificationList: build.query<NotificationTypes[], void>({
      query: () => ({
        url: `${API_NOTIFICATION}/Notifications`
      }),
      providesTags: ['notificationList' as any]
    }),
    updateNotification: build.mutation<any, NotificationUpdatePayloadTypes>({
      query: (data) => ({
        url: `${API_NOTIFICATION}/Update`,
        method: 'put',
        data
      }),
      invalidatesTags: ['notificationCount', 'notificationList' as any]
    })
  })
});

export const { useGetNotificationCountQuery, useGetNotificationListQuery, useUpdateNotificationMutation } = notificaitonApi;

export default notificaitonApi;
